export default __webpack_public_path__ + "media/images/map/car/512x512-d3c670e42d815c61f3a57f1bec74f2b5.png";